export default __webpack_public_path__ + "static/media/wip1.88702dea.jpeg";